import useCheckServer from '../../utils/hooks/useCheckServer';
import useHealthCheck from '../../utils/hooks/useHealthCheck';
import useCheckingCtrl from '../../utils/hooks/useCheckingCtrl';

const ServiceChecker = () => {
  const ctrl = useCheckingCtrl();

  useHealthCheck(ctrl);
  useCheckServer(ctrl);

  return null;
};

export default ServiceChecker;
